import isAcceptedClosedRoute from './isAcceptedClosedRoute';
import isAcceptedOpenOrClosed from './isAcceptedOpenOrClosed';

function shouldUpdateStatusFilter(route, nextRoute) {
  if (route.status !== nextRoute.status) {
    return true;
  }

  return isAcceptedOpenOrClosed(route.status) &&
    isAcceptedClosedRoute(route) !== isAcceptedClosedRoute(nextRoute);
}

export default shouldUpdateStatusFilter;
